<mf-page title="Nueva plantilla de correo">
  <mf-template
    [templateDto]="templateEmailDto"
    (save)="save($event)"
    (closeButtonClick)="close()" />
</mf-page>
